<template>
  <div style="text-align: center">
    <Card style="width:1000px;display: inline-block;">
      <h4 style="font-size: 24px;">We love to hear your feedback !</h4>
      <Rate allow-half v-model="postData.score" style="font-size: 24px"/>
      <Alert type="warning" style="font-size: 16px;font-weight: bold">UPDATE NOTES !!! We have recently added the email system to ensure timely receiving of user information on the feedback page. More importantly, users can add images, links, and videos (&lt;1GB) directly to the feedback page to make it easier to use. </Alert>
      <Divider/>
      <div style="width: 100%;text-align: left;font-size: 18px">
        please select your feedback category below.
        <div style="width: 100%;margin-top: 20px;margin-bottom:20px;text-align: center">
          <RadioGroup v-model="postData.suggestType" type="button" size="large" style="font-size: 18px !important;">
            <Radio label="01" style="font-size: 18px !important;">Suggestion</Radio>
            <Radio label="02" style="font-size: 18px !important;">Something is not quite right</Radio>
            <Radio label="03" style="font-size: 18px !important;">Compliment</Radio>
          </RadioGroup>
        </div>
        <p v-if="hasName">hello,{{ easyflyName }}</p>
        <Input prefix="ios-contact" v-if="!hasName" v-model="postData.name" placeholder="Enter name"
               size="large"
               style="width: 40%"/>
        <Input prefix="ios-mail" v-if="!hasName" v-model="postData.email" placeholder="Enter email"
               size="large"
               style="width: 40%;margin-left: 10%"/>
<!--        <Input style="margin-top: 20px" :rows="8" v-model="postData.suggestion" type="textarea"-->
<!--               size="large"-->
<!--               placeholder="Enter something..."/>-->
        <comment-edit style="margin-top: 20px" :default-html="postData.suggestion" @changeHtml="changeHtml"/>
        <Button style="margin-top: 20px" type="success" long size="large" @click="submitData">Send Your Message
        </Button>
      </div>
    </Card>
    <v-loading :show="loading"></v-loading>
  </div>
</template>

<script>
import util from "../util/util";
import CommentEdit from "../public/commentEdit.vue";
import VLoading from "../public/v-loading.vue";

export default {
  name: "feedBack",
  components: {VLoading, CommentEdit},
  data(){
    return{
      loading : false,
      postData: {
        score: 4.5,
        suggestType: "01",
        suggestion: "",
        name: "",
        email: ""
      },
      easyflyName: "",
    }
  },
  mounted() {
    this.easyflyName = this.$cookies.get("easyflyName");
  },
  methods:{
    changeHtml(html){
      this.postData.suggestion = html;
    },
    submitData: function () {
      if (this.hasName) {
        this.postData.name = this.$cookies.get("easyflyName");
        this.postData.email = this.$cookies.get("easyflyEmail");
      }
      if (util.isNull(this.postData.name)) {
        this.$Message.error("please enter name");
        return;
      }
      if (util.isNull(this.postData.email)) {
        this.$Message.error("please enter email");
        return;
      }
      var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (!reg.test(this.postData.email)) {
        this.$Message.error("email is not allow");
        return;
      }
      if (util.isNull(this.postData.suggestion)) {
        this.$Message.error("please enter suggestion");
        return;
      }
      var _ = this;
      this.$cookies.set("easyflyName", this.postData.name);
      this.$cookies.set("easyflyEmail", this.postData.email);
      var post = {
        name: this.postData.name,
        email: this.postData.email,
        suggestion: this.postData.suggestion,
        flag: this.postData.suggestType,
        score: this.postData.score,
        curstatu: "system"
      }
      this.loading = true;
      this.$axios.post("/suggestion/submit", {postData: JSON.stringify(post)}).then(function (res) {
        console.log(res);
        _.$Message.success("submit success");
        _.$emit("submitSuccess", _.postData.suggestType)
      }).catch(function (res) {
        console.log(res);
        _.$Message.error("something error");
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  computed: {
    hasName: function () {
      if (util.isNull(this.$cookies.get("easyflyName"))) {
        return false;
      }
      return true;
    }
  }
}
</script>

<style scoped>
.detail-item {
  width: 90%;
  display: inline-block;
  cursor: pointer;
}

.mid-div {
  width: 100%;
  text-align: center;
}

.bottom-div {
  margin-top: 20px;
  width: 100%;
}
.ivu-card{
  background-color:rgba(255,255,255,0.6);
}
.mouse-div{
  position: absolute;
  bottom: 20px;
  right: 20px;
  height: 50px;
  width: 50px;
  display: inline-block;
}

@keyframes fade {
  from {
    opacity: 1.0;
  }
  50% {
    opacity: 0.4;
  }
  to {
    opacity: 1.0;
  }
}

@-webkit-keyframes fade {
  from {
    opacity: 1.0;
  }
  50% {
    opacity: 0.4;
  }
  to {
    opacity: 1.0;
  }
}
.headerBox {
  color: #fff;
  padding: 10px;
  font-size: 15px;
  height: 60px;
  animation: fade 600ms infinite;
  -webkit-animation: fade 600ms infinite;
}
</style>